import { render, staticRenderFns } from "./screwCheck.vue?vue&type=template&id=1c2bcdaa&scoped=true&"
import script from "./screwCheck.vue?vue&type=script&lang=js&"
export * from "./screwCheck.vue?vue&type=script&lang=js&"
import style0 from "./screwCheck.vue?vue&type=style&index=0&id=1c2bcdaa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2bcdaa",
  null
  
)

export default component.exports